import React from 'react';

import { CollectionAsset } from '@kaltura-ott/tvpil-shared';

import { RAIL_PAGE_SIZE } from 'consts';
import WidgetProvider from 'context/widgetProvider/widgetProvider';

import RailProvider from '../components/RailProvider/RailProvider';
import RailSkeleton from '../components/RailSkeleton/RailSkeleton';

import RecommendationRailContainer from './components/RecommendationRailContainer/RecommendationRailContainer';
import { useRecommendationRail } from './hooks/useRecommendationRail/useRecommendationRail';

interface Props {
  referenceId: string;
}

function RecommendationRail({ referenceId }: Props) {
  const {
    railData,
    railType,
    isLoading,
    railSettings,
    isRailHidden,
    shouldPreventDisplay,
    handleSkeletonRef,
  } = useRecommendationRail(referenceId);

  if (!railSettings || isRailHidden) {
    return null;
  }

  if (shouldPreventDisplay || isLoading) {
    return (
      <RailSkeleton
        handleRef={handleSkeletonRef}
        settings={railSettings}
        numberOfCells={RAIL_PAGE_SIZE}
        shouldShowHeader
      />
    );
  }

  return (
    <WidgetProvider<CollectionAsset> type={railType} settings={railSettings!} data={railData}>
      <RailProvider referenceId={referenceId}>
        <RecommendationRailContainer />
      </RailProvider>
    </WidgetProvider>
  );
}

export default RecommendationRail;
